import { dateFormat, successMessageToast, truncateUrl, userFullName } from "helpers/common";
import { store } from "store/store";
import { useLazyGetFileUrlQuery } from "store/services/utility";
import LoadingOverlay from "components/shared/LoadingOverlay";
import { CommonSelect, CommonToolTip, NoRecordFoundV2 } from "components/Common/Common";
import { useEffect, useState } from "react";
import downArrow from "Assets/images/downArrowPurple.png"
import downArrowNormal from 'Assets/images/downArrowBlack.png'
import upArrow from "Assets/images/upArrowPurple.png"
import { Col, Row } from "react-bootstrap";
import { DOCUMENTS_FILTER_OPTIONS } from "config/constants";
import NoRecordAddDetails from "components/NoRecordAddDetails";
import UpArrowIcon from "Assets/images/UpArrowIcon";
import DownArrowIcon from "Assets/images/DownArrowIcon";
import { useDeleteResourceMutation, useRestoreResourceMutation } from "store/services/resource";
import confirmDialogV2 from "utils/confirmationDialogV2";
import { DeleteIcon, RefreshIcon } from "Assets/icons";

const ClientAttachments = ({ onClick, resources, limit, filter = {}, isPage = false, isDisabled = false }) => {

    const [sortField, setSortField] = useState("date");   // date | type | name
    const [sortOrder, setSortOrder] = useState("desc");   // asc | desc
    const [resourcesList, setResourcesList] = useState(resources || []);

    const attachments = resourcesList
        ?.filter(x => x.type === "attachment")
        ?.filter(x =>
            filter.resource_type
                ? x.resource_type === filter.resource_type
                : true
        );

    const [getFileUrl, { isLoading: getFileLoading, isFetching: getFileFetching }] = useLazyGetFileUrlQuery();
    const [removeFileApi, { isLoading: isRemoving }] = useDeleteResourceMutation();
    const [restoreFile, { isLoading: restoreFileLoading }] = useRestoreResourceMutation();

    const handleDelete = async (e, id) => {
        e.stopPropagation();
        try {

            const isConfirm = await confirmDialogV2({
                title: "DELETE DOCUMENT ?",
                message: "Are you sure you want to delete this document ?",
            });
            if (!isConfirm) {
                return;
            }

            const result = await removeFileApi(id).unwrap();

            setResourcesList((prev) => prev?.map((item) => item.id == id ? { ...item, deletedAt: new Date() } : item));
            successMessageToast(result?.message);

        } catch (err) { console.error("Error deleting document", err); }
    };

    const handleRestore = async (e, id) => {
        e.stopPropagation();
        try {
            const isConfirm = await confirmDialogV2({
                title: "RESTORE DOCUMENT ?",
                message: "Are you sure you want to restore this document ?",
            });
            if (!isConfirm) {
                return;
            }

            const result = await restoreFile(id).unwrap();

            setResourcesList((prev) => prev?.map((item) => item.id == id ? { ...item, deletedAt: null } : item));
            successMessageToast(result?.message);

        } catch (err) { console.error("Error restoring document", err); }
    };

    const handleViewPdf = async (name) => {

        try {
            const result = await getFileUrl(name);
            if (result?.error) return;

            const url = result?.data
            if (url) window.open(url, '_blank');

        } catch (err) { console.error("Error assigning therapist", err); }
    };

    const handleSort = (field) => {
        if (sortField === field) {
            setSortOrder(sortOrder === "asc" ? "desc" : "asc");
        } else {
            setSortField(field);
            setSortOrder("desc"); // default order
        }
    };

    useEffect(() => {
        setResourcesList(resources || []);
    }, [resources]);

    const sortedAttachments = attachments
        ? [...attachments].sort((a, b) => {
            let A = "", B = "";

            // DATE SORTING
            if (sortField === "date") {
                A = new Date(a?.createdAt || a?.updatedAt);
                B = new Date(b?.createdAt || b?.updatedAt);
            }

            // TYPE SORTING
            if (sortField === "type") {
                A = a?.resource_type?.toLowerCase() || "";
                B = b?.resource_type?.toLowerCase() || "";
            }

            // NAME SORTING
            if (sortField === "name") {
                A = a?.attachment_name?.toLowerCase() || "";
                B = b?.attachment_name?.toLowerCase() || "";
            }

            if (sortOrder === "asc") {
                return A > B ? 1 : -1;
            } else {
                return A < B ? 1 : -1;
            }
        })
        : [];

    //Get the bg color accrding  to type
    const bgColors = {
        consent: "#ECFFDB",
        document: "#DBF8FB",
        report: "#FFE9FA",
    };

    const getBgColor = (name) => bgColors[name?.toLowerCase()] || "transparent";


    return (
        <>
            {(getFileFetching || restoreFileLoading || isRemoving) && <LoadingOverlay />}
            <div className="mt-2">
                <table className="w-100">
                    <thead>
                        <tr>
                            <th onClick={() => handleSort("type")} className="fw-medium proxima" style={{ padding: "15px 10px", borderBottom: "2px solid #315D99" }}>
                                <div className={`${sortField == 'type' && "themeBlueV2 cursor-pointer"} d-flex ten gap-2 align-items-center`}>
                                    TYPE
                                    {/* <img width={9} height={9} src={sortField === "type" ? (sortOrder === "asc" ? upArrow : downArrow) : downArrowNormal} /> */}
                                    {sortField === "type" ? (sortOrder === "asc" ? <UpArrowIcon color={sortOrder === "asc"} /> : <DownArrowIcon color={sortOrder === "desc"} />) : <DownArrowIcon />}
                                </div>
                            </th>
                            <th onClick={() => handleSort("name")} className="fw-medium proxima" style={{ padding: "15px 10px", borderBottom: "2px solid #315D99" }}>
                                <div className={`${sortField == 'name' && "themeBlueV2 cursor-pointer"} d-flex ten gap-2 align-items-center`}>
                                    NAME
                                    {sortField === "name" ? (sortOrder === "asc" ? <UpArrowIcon color={sortOrder === "asc"} /> : <DownArrowIcon color={sortOrder === "desc"} />) : <DownArrowIcon />}
                                </div>
                            </th>
                            <th onClick={() => handleSort("date")} className="fw-medium proxima" style={{ padding: "15px 10px", borderBottom: "2px solid #315D99" }}>
                                <div className={`${sortField == 'date' && "themeBlueV2 cursor-pointer"} d-flex gap-2 ten align-items-center`}>
                                    DATE
                                    {sortField === "date" ? (sortOrder === "asc" ? <UpArrowIcon color={sortOrder === "asc"} /> : <DownArrowIcon color={sortOrder === "desc"} />) : <DownArrowIcon />}
                                </div>
                            </th>
                            <th className="fw-medium proxima" style={{ padding: "15px 10px", borderBottom: "2px solid #315D99" }}>
                                <div className="d-flex gap-2 ten align-items-center">
                                    ACTION
                                </div>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            sortedAttachments?.length > 0 ? sortedAttachments?.map((item, index) => {
                                if (limit && index >= limit) return null;

                                return (
                                    <tr
                                        className="cursor-pointer"
                                        onClick={() => handleViewPdf(item?.attachment_key)}
                                        key={index}
                                    >
                                        <td
                                            className="text-capitalize"
                                            style={{
                                                color: "#000",
                                                padding: "15px 10px",
                                                borderRadius: 0,
                                                borderBottom: "1px solid #8F8F8F",
                                            }}
                                        >
                                            <span
                                                className="proxima"
                                                style={{
                                                    background: getBgColor(item?.resource_type),
                                                    padding: "8px",
                                                    borderRadius: "10%",
                                                    width: "100%",
                                                    display: "block",
                                                    textAlign: "center",
                                                    color: "#000",
                                                    fontSize: "12px",
                                                }}
                                            >
                                                {item?.resource_type}
                                            </span>

                                        </td>

                                        <td
                                            style={{
                                                padding: "15px 10px",
                                                borderRadius: 0,
                                                borderBottom: "1px solid #8F8F8F",
                                            }}
                                        >
                                            <CommonToolTip
                                                component={
                                                    <h6
                                                        className="proxima"
                                                        style={{
                                                            textOverflow: "ellipsis",
                                                            overflow: "hidden",
                                                            fontSize: "14px",
                                                            whiteSpace: "nowrap",
                                                            color: "#000",
                                                            fontSize: "12px",
                                                        }}
                                                    >
                                                        {truncateUrl(item?.attachment_name, 40)}
                                                    </h6>
                                                }
                                                text={decodeURIComponent(item?.attachment_name)}
                                            />
                                        </td>

                                        <td
                                            className="proxima"
                                            style={{
                                                padding: "15px 10px",
                                                borderRadius: 0,
                                                borderBottom: "1px solid #8F8F8F",
                                                color: "#000",
                                                fontSize: "12px",
                                            }}
                                        >
                                            {dateFormat(item?.createdAt, "MMM DD, YYYY")}
                                        </td>
                                        <td
                                            className="proxima"
                                            style={{
                                                padding: "15px 10px",
                                                borderRadius: 0,
                                                borderBottom: "1px solid #8F8F8F",
                                                color: "#000",
                                                fontSize: "12px",
                                            }}
                                        >
                                            {!isDisabled && (
                                                !item?.deletedAt ? <CommonToolTip
                                                    text="Delete"
                                                    component={
                                                        <DeleteIcon
                                                            className="cursor-pointer"
                                                            onClick={(e) => handleDelete(e, item?.id)}
                                                        />
                                                    }
                                                />
                                                    : <CommonToolTip
                                                        text="Restore"
                                                        component={
                                                            <RefreshIcon
                                                                className="cursor-pointer mx-1"
                                                                onClick={(e) => handleRestore(e, item?.id)}
                                                            />
                                                        }
                                                    />
                                            )}
                                        </td>
                                    </tr>
                                );
                            }) :
                                <tr>
                                    <td colSpan="4" className="text-center px-0">
                                        <NoRecordAddDetails onClick={onClick} title='Add a document' />
                                    </td>
                                </tr>
                        }

                    </tbody>
                </table>
            </div>

        </>
    );
};

export default ClientAttachments;
